import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    searchUrl: String,
    optionUrl: String,
  };

  connect() {
    const url = `${this.optionUrlValue}?ids=${this.element.value}`;
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        this.init(json);
      })
      .catch(() => {
        this.init([]);
      });
  }

  init(options) {
    options ||= [];
    new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'title',
      searchField: 'title',
      plugins: ['remove_button'],
      maxOptions: 10,
      closeAfterSelect: true,
      options,
      onDelete: function (values) {
        return false;
      },
      //fetch remote data
      load: (query, callback) => {
        const url = `${this.searchUrlValue}?search=${encodeURIComponent(query)}`;
        fetch(url)
          .then((response) => response.json())
          .then((json) => callback(json))
          .catch(() => callback());
      },
      //custom rendering functions for options and items
      render: {
        option: function (item, escape) {
          return `<div class="py-2 flex space-x-2">
                    <div class="text-primary-600 font-blod">
                      #${item.id}
                    </div>
                    <div>
                      ${escape(item.title)}
                    </div>
                  </div>`;
        },
        item: function (item, escape) {
          return `<div class="py-2 flex space-x-2">
                    <div class="text-primary-600 font-blod">
                      #${item.id}
                    </div>
                    <div>
                      ${escape(item.title)}
                    </div>
                  </div>`;
        },
        no_results: function (data, escape) {
          return '<div class="no-results">해당 제목을 가진 게시물이 없습니다.</div>';
        },
      },
    });
  }
}
